import { observer } from 'mobx-react';
import * as React from 'react';
import { inject } from '../../../utils/decorators';
import { AuftragStore } from '../../../stores/AuftragStore';
import Callout from '../../site/Callout';
import { BpsReferenzkraftKalibrierungStore } from '../../../stores/BpsReferenzkraftKalibrierungStore';
import { Panel } from 'react-bootstrap';

/** Komponente zur Anzeige der für die Kalibrierung relevanten Daten zum gewählten Bremsenprüfstand */
@observer
export default class BpsReferenzkraftObjektInfo extends React.Component<{}, {}> {

  @inject(AuftragStore) auftragStore: AuftragStore;
  @inject(BpsReferenzkraftKalibrierungStore) kalibrierungStore: BpsReferenzkraftKalibrierungStore;

  render() {
    const kalibrierGegenstand = this.kalibrierungStore.kalibrierGegenstand;
    if (kalibrierGegenstand && kalibrierGegenstand.objekt) {
      const bezeichner = `${kalibrierGegenstand.objekt.hersteller} ${kalibrierGegenstand.objekt.typbezeichnung} (${kalibrierGegenstand.meta('fzart')})`;
      return (
        <Panel header={bezeichner} collapsible={true} defaultExpanded={false}>
          <p>{kalibrierGegenstand.objekt.art}</p><br/>
          <b>Hebelarmlänge:</b> {kalibrierGegenstand.meta('hebelarmlänge')} mm<br/>
          <b>Nenndurchmesser Rolle:</b> {kalibrierGegenstand.meta('rollendurchmesser')} mm<br/>
          <b>Übersetzung:</b> {kalibrierGegenstand.meta('übersetzungsverhältnis_zähler')} : {kalibrierGegenstand.meta('übersetzungsverhältnis_nenner')}<br/>
          <b>Anzeige:</b> <span className="capitalize">{kalibrierGegenstand.meta('anzeigeart')}</span> mit {kalibrierGegenstand.meta('anzeigeaufloesung')} N Auflösung<br/>
        </Panel>
      );
    } else {
      return (
        <Callout bsStyle="danger">
          <p>Es wurde noch kein Bremsenprüfstand im Auftrag ausgewählt!</p>
        </Callout>
      );
    }
  }

}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/components/vorlagen/bps/BpsReferenzkraftObjektInfo.tsx